export const ANIMATIONS = {
  CONFETTI: 'CONFETTI',
  EXPLODING_CONFETTI: 'EXPLODING_CONFETTI',
}
